<div class="wrapper">
    <button (click)="toggleMobileSidebar()" *ngIf="!isMobileSidebarOpen"
            [attr.aria-label]="'Open menu' | translate"
            [title]="'Menu' | translate" class="mobile-menu-button"
            type="button">
        <i class="material-icons">menu</i>
    </button>
    <button (click)="closeMobileSidebar()"
            *ngIf="isMobileSidebarOpen"
            [attr.aria-label]="'Close menu' | translate"
            class="mobile-sidebar-backdrop"
            type="button"></button>
    <app-sidebar (navigationSelected)="closeMobileSidebar()" [isOpen]="isMobileSidebarOpen"></app-sidebar>
    <div class="main-panel">
        <nav class="app-topbar" id="navigation-example">
            <app-header [pageName]="pageName" [userInfo]="userInfo"></app-header>
        </nav>
        <main class="content">
            <router-outlet></router-outlet>
        </main>
        <footer class="app-footer">
            <app-footer></app-footer>
        </footer>
    </div>
</div>
